import { render, staticRenderFns } from "./SonglistDetail.vue?vue&type=template&id=5d3a73e9&scoped=true&"
import script from "./SonglistDetail.vue?vue&type=script&lang=js&"
export * from "./SonglistDetail.vue?vue&type=script&lang=js&"
import style0 from "./SonglistDetail.vue?vue&type=style&index=0&id=5d3a73e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3a73e9",
  null
  
)

export default component.exports